import ReactTooltip from "react-tooltip";
import Span from "../smallComponents/Span";
import PropTypes from "prop-types";

const TableHeader = ({
  tableHeaderData,
  requestSort,
  sortConfig,
  ...props
}) => {
  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  return tableHeaderData.map((header, index) => (
    <th data-tip data-for={header.type} key={index} {...props}>
      <Span
        label={header.label}
        type={header.type}
        requestSort={requestSort}
        getClassNamesFor={getClassNamesFor}
      />
      <ReactTooltip
        id={header.type}
        place={header?.place ? header.place : "top"}
        effect="solid"
        type="info"
      >
        {header.toolTipText}
      </ReactTooltip>
    </th>
  ));
};

TableHeader.propTypes = {
  tableHeaderData: PropTypes.array.isRequired,
  requestSort: PropTypes.func.isRequired,
  sortConfig: PropTypes.object
};

export default TableHeader;
